<i18n>
  {
    "en": {
      "app-name": "AI Server",
      "message": {
        "hello": "hello world"
      }
    },
    "zh-tw": {
      "app-name": "AI 服務生",
      "message": {
        "hello": "chinese hello"
      }
    }
  }
</i18n>

<template>
  <f7-page :color-theme="themeColor">
    <f7-navbar>
      <f7-nav-title>{{ $t('app-name') }}</f7-nav-title>
      <f7-nav-right>
        <!-- <f7-link href="#">切換</f7-link> -->
      </f7-nav-right>
    </f7-navbar>

    <div style="margin: 15px 20px;">
      <img :src="photoURL" width="48" style="border-radius: 50%; margin: 10px 0px;" />
      <div>{{ displayName }}</div>
      <div>{{ email }}</div>
    </div>

    <f7-list style="margin: 0px;">
      <f7-list-item group-title>{{ fullStoreName || '尚未選擇店家' }}</f7-list-item>
      <template v-if="storeId">
        <f7-list-item :link="`/stores/${storeId}/dashboard`" title="控制台" view="#main-view" panel-close />
        <f7-list-item v-if="hasPermissions(permissionType.getStatistics)" :link="`/stores/${storeId}/statistics`" title="統計資料" view="#main-view" panel-close />
        <!-- <f7-list-item :link="`/stores/${storeId}/management`" title="後台管理系統" view="#main-view" panel-close /> -->
        <f7-list-item v-if="hasPermissions(permissionType.getUserPermission)" :link="`/stores/${storeId}/employee`" title="員工管理系統" view="#main-view" panel-close />
        <f7-list-item v-if="hasPermissions(permissionType.getStoreMenuDraft)" :link="`/stores/${storeId}/menu-list`" title="菜單管理" view="#main-view" panel-close />
        <f7-list-item v-if="hasPermissions(permissionType.updateStoreInfo)" :link="`/stores/${storeId}/store-info-settings/table-numbers`" title="桌號編輯" view="#main-view" panel-close />
        <f7-list-item v-if="hasPermissions(permissionType.updateStoreInfo)" :link="`/stores/${storeId}/business-hours`" title="營業時間管理" view="#main-view" panel-close />
        <f7-list-item v-if="hasPermissions(permissionType.getOrder)" :link="`/stores/${storeId}/orders`" title="訂單管理" view="#main-view" panel-close />
        <f7-list-item v-if="hasPermissions(permissionType.getOrder)" :link="`/stores/${storeId}/work-station`" title="分工畫面" view="#main-view" panel-close />
        <f7-list-item v-if="hasPermissions(permissionType.updateOrderPaymentStatus)" :link="`/stores/${storeId}/invoice-failed`" title="電子發票上傳" view="#main-view" panel-close />
        <f7-list-item v-if="hasPermissions(permissionType.getStoreInfo)" :link="`/stores/${storeId}/store-info-settings`" title="餐廳基本設定" view="#main-view" panel-close />
        <f7-list-item :link="`/stores/${storeId}/qr-code-download`" title="下載 QR code" view="#main-view" panel-close />
      </template>
      <f7-list-item v-if="uid" title="切換店家" link="#" @click="$f7.views.main.router.navigate('/', { reloadAll: true })" panel-close />
      <f7-list-item group-title>設備</f7-list-item>
      <f7-list-item link="/user-cashiers" title="收銀機" view="#main-view" panel-close />
      <f7-list-item :link="`/user-monitors`" title="叫號螢幕" view="#main-view" panel-close />

      <f7-list-item group-title>系統</f7-list-item>
      <f7-list-item :link="`/info`" title="系統資訊" view="#main-view" panel-close />
      <f7-list-item :link="`/system-settings`" title="系統設定" view="#main-view" panel-close />

      <f7-list-item group-title>帳號</f7-list-item>
      <f7-list-item :link="`/account`" title="帳號管理" view="#main-view" panel-close />
      <f7-list-item v-if="uid" title="登出使用者" link="#" panel-close @click="signOutOnClick()" />
      <f7-list-item v-else title="登入" link="/auth" view="#main-view" reload-current panel-close />
    </f7-list>
  </f7-page>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  dependencies: ['themeColor', 'permissionType'],
  computed: {
    ...mapState('userModule', [
      'uid',
      'name',
      'email',
      'displayName',
      'photoURL',
      'permissions'
    ]),
    ...mapGetters(['storeId', 'fullStoreName'])
  },
  methods: {
    ...mapActions('userModule', ['signOut']),
    hasPermissions (permissions) {
      if (typeof permissions === 'string') {
        return (!!this.permissions[this.storeId] && this.permissions[this.storeId][permissions]) || (!!this.permissions['*'] && this.permissions['*'][permissions])
      } else if (permissions instanceof Array) {
        //
      }
      return false
    },
    signOutOnClick () {
      this.signOut()
      this.$f7.views.main.router.navigate('/auth', { reloadCurrent: true })
    }
  }
}
</script>
